import { InventoryLine } from './InventoryLine';

export class InventoryCategory {
  constructor(private readonly name: string, private readonly lines: InventoryLine[]) {
    this.lines = lines || [];
  }

  getName() {
    return this.name;
  }

  getLines() {
    return this.lines;
  }
}
